import styled from 'styled-components';
import { StyleColor, navBarHeight, blurredBackgroundColor, Format, BaseStyledComponentProps } from '../../utils/styles-constants';
import { overlayAnimation } from '../../utils/style';

interface StyledBlurPanelProps {
	isOpen: boolean;
}

interface BlurPanelHeaderButtonProps {
	isLeft?: boolean;
	isRight?: boolean;
}

const StyledBlurPanel = styled('div')`
	${ (props: StyledBlurPanelProps) => overlayAnimation(props.isOpen) };
	z-index: 11;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
`;

const BlurPanelHeader = styled('div')`
	position: absolute;
	height: ${navBarHeight};
	top: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${StyleColor.White};

	font-size: 16px;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
`;

const BlurPanelHeaderButton = styled('div')`
	position: absolute;
	top: 6px;
	left: ${(props: BlurPanelHeaderButtonProps) => props.isLeft ? '50px' : 'auto'};
	right: ${(props: BlurPanelHeaderButtonProps) => props.isRight ? '50px' : 'auto'};
	padding: 10px;
	cursor: pointer;

	@media ${Format.SmartphonePortrait} {
		left: ${(props: BlurPanelHeaderButtonProps) => props.isLeft ? 0 : 'auto'};
		right: ${(props: BlurPanelHeaderButtonProps) => props.isRight ? 0 : 'auto'};
	}
`;

const BlurPanelHeaderLabel = styled('div')`
	font-weight: 500;
	font-size: 18px;
	color: ${StyleColor.Black};

	@media ${Format.SmallSmartphonePortrait} {
		max-width: 50%;
		text-align: center;
	}
`;

const BlurPanelContent = styled('div')`
	backdrop-filter: blur(20px);
	position: absolute;
	top: ${navBarHeight};
	bottom: 0;
	left: 0;
	right: 0;
`;

const BlurPanelContentBackground = styled('div')`
	height: 100%;
	background-color: ${blurredBackgroundColor};
	display: flex;
	justify-content: center;
`;

export {
	StyledBlurPanel,
	BlurPanelHeader,
	BlurPanelHeaderButton,
	BlurPanelHeaderLabel,
	BlurPanelContent,
	BlurPanelContentBackground,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/BlurPanel/styles.ts